import { Controller } from '@hotwired/stimulus';

// Polls the Brand page's digest-status endpoint while "What We've Learned" is
// still being generated, then swaps the section in place the moment it's ready.
// No full-page reload, so the brand voice/links form above is never clobbered.
export default class extends Controller {
  static targets = ['content'];
  static values = {
    statusUrl: String,
    ready: Boolean,
    interval: { type: Number, default: 5000 },
    maxWait: { type: Number, default: 240000 }, // give up polling after 4 min
  };

  connect() {
    if (this.readyValue) return; // digest already present — nothing to wait for
    this.startedAt = Date.now();
    this.timer = setInterval(() => this.poll(), this.intervalValue);
  }

  disconnect() {
    this.stop();
  }

  async poll() {
    if (Date.now() - this.startedAt > this.maxWaitValue) {
      this.stop();
      return;
    }

    try {
      const res = await fetch(this.statusUrlValue, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;

      const data = await res.json();
      if (data.ready && data.html && this.hasContentTarget) {
        this.contentTarget.innerHTML = data.html;
        this.stop();
      }
    } catch (err) {
      // Transient network hiccup — keep polling until maxWait.
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
